module.exports = __webpack_public_path__ + "093e1c48e83c0809abf3c3f17865ec5a.svg";